import {
  AlertCircle,
  Check,
  Clock,
  Loader2,
  PackageCheck,
  Cog,
  Truck,
} from 'lucide-react';

const getStatusInfo = (status?: string) => {
  switch (status) {
    case 'Processing':
      return {
        icon: <Cog />,
        color: '#FEF3C7',
        textColor: '#92400E',
        borderColor: '#FDE68A',
        label: 'Processing',
      };
    case 'awaiting_fulfillment':
      return {
        icon: <Cog />,
        color: '#FEF3C7',
        textColor: '#92400E',
        borderColor: '#FDE68A',
        label: 'Processing',
      };

      case 'Awaiting_fulfillment':
        return {
          icon: <Cog />,
          color: '#FEF3C7',
          textColor: '#92400E',
          borderColor: '#FDE68A',
          label: 'Processing',
        };
    case 'Pending':
      return {
        icon: <Cog />,
        color: '#FEF3C7',
        textColor: '#92400E',
        borderColor: '#FDE68A',
        label: 'Processing',
      };
    case 'Submitted':
      return {
        icon: <Cog />,
        color: '#FEF3C7',
        textColor: '#92400E',
        borderColor: '#FDE68A',
        label: 'Processing',
      };
    case 'Fulfilled':
      return {
        icon: <Truck />,
        color: '#DBEAFE',
        textColor: '#1E40AF',
        borderColor: '#BFDBFE',
        label: 'Shipped',
      };
    case 'Shipped':
      return {
        icon: <Truck />,
        color: '#DBEAFE',
        textColor: '#1E40AF',
        borderColor: '#BFDBFE',
        label: 'Shipped',
      };
    case 'shipped':
      return {
        icon: <Truck />,
        color: '#DBEAFE',
        textColor: '#1E40AF',
        borderColor: '#BFDBFE',
        label: 'Shipped',
      };
    case 'Delivered':
      return {
        icon: <PackageCheck />,
        color: '#DBEAFE',
        textColor: '#1E40AF',
        borderColor: '#BFDBFE',
        label: 'Delivered',
      };
    case 'delivered':
      return {
        icon: <PackageCheck />,
        color: '#DBEAFE',
        textColor: '#1E40AF',
        borderColor: '#BFDBFE',
        label: 'Delivered',
      };
    case 'Exception':
      return {
        icon: <AlertCircle />,
        color: '#FEE2E2',
        textColor: '#991B1B',
        borderColor: '#FECACA',
        label: 'Error',
      };
    case 'exception':
      return {
        icon: <AlertCircle />,
        color: '#FEE2E2',
        textColor: '#991B1B',
        borderColor: '#FECACA',
        label: 'Error',
      };
    case 'Cancelled':
      return {
        icon: <AlertCircle />,
        color: '#FEE2E2',
        textColor: '#991B1B',
        borderColor: '#FECACA',
        label: 'Error',
      };
    case 'Failed':
      return {
        icon: <AlertCircle />,
        color: '#FEE2E2',
        textColor: '#991B1B',
        borderColor: '#FECACA',
        label: 'Error',
      };
    case 'Acknowledgement Signed':
      return {
        icon: <Check />,
        color: '#D1FAE5',
        textColor: '#065F46',
        borderColor: '#A7F3D0',
        label: 'Delivered',
      };
    default:
      return {
        icon: <Clock />,
        color: '#F3F4F6',
        textColor: '#374151',
        borderColor: '#E5E7EB',
        label: 'No Status',
      };
  }
};

export default getStatusInfo;
